import { GlobalStore } from "../../../../../store/global/GlobalStore";

export const HorizontalLine = () => {
  const theme = GlobalStore.useState(s => s.theme);
  return (
    <hr
      className="hr-m-15"
      style={{
        borderTop: theme.formfield.text.resting,
      }}
    />
  );
};
